function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { FaEdit, FaCircle } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import MenuSelect from '../../components/MenuSelect';
import { deleteLabelClass, setLabelClassName, setLabelClassColor, deleteAllImages, toggleDisposeState } from '../../redux/actions/labelClasses';
import ColorSelector from '../../components/ColorSelector';
import { deleteExamples } from '../../shared/image_classifier';

var Header = function Header(_ref) {
  var labelClass = _ref.labelClass;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      edit = _useState2[0],
      setEdit = _useState2[1];

  var dispatch = useDispatch();
  var menuOptions = [['Delete Class', function () {
    deleteExamples(labelClass.name);
    dispatch(deleteLabelClass(labelClass.id));
  }], ['Remove All Images', function () {
    deleteExamples(labelClass.name);
    dispatch(deleteAllImages(labelClass.id));
  }]];

  var handleUpdate = function handleUpdate(e) {
    toggleEdit();
    dispatch(setLabelClassName(labelClass.id, e.target.value));
  };

  var toggleEdit = function toggleEdit(e) {
    setEdit(!edit);
  };

  var handleEnter = function handleEnter(e) {
    if (e.key === 'Enter') {
      setEdit(false);
      handleUpdate(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "panel--round__header flex-row-container flex-justify-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container"
  }, /*#__PURE__*/React.createElement(ColorSelector, {
    colorSetter: function colorSetter(id, color) {
      return dispatch(setLabelClassColor(id, color));
    },
    backgroundColor: labelClass.color.hex,
    id: labelClass.id
  }), /*#__PURE__*/React.createElement("button", {
    className: "edit-title-btn",
    onClick: toggleEdit
  }, /*#__PURE__*/React.createElement(FaEdit, null)), edit ? /*#__PURE__*/React.createElement("input", {
    autoFocus: true,
    onKeyPress: handleEnter,
    type: "text",
    id: "name",
    onBlur: handleUpdate
  }) : /*#__PURE__*/React.createElement("b", {
    className: "class-title"
  }, labelClass.name)), /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container"
  }, /*#__PURE__*/React.createElement("label", {
    className: "toggle-label-static"
  }, "Mark items in this category:"), /*#__PURE__*/React.createElement("button", {
    className: labelClass.dispose ? 'toggle-btn__dispose' : 'toggle-btn__keep',
    onClick: function onClick() {
      return dispatch(toggleDisposeState(labelClass.id));
    }
  }, /*#__PURE__*/React.createElement(FaCircle, null)), /*#__PURE__*/React.createElement("label", {
    className: "toggle-label"
  }, labelClass.dispose ? 'DEFECT' : 'OK'), /*#__PURE__*/React.createElement(MenuSelect, {
    options: menuOptions
  })));
};

export default Header;